import * as React from "react";
import { BannerContainer } from "../../../../components/BannerContainer";
import { ProductInfoGrid3 } from "../../../LayerUI/ProductInfoViews";
import { TripleCardWrap } from "../styles.card";
import { ProductCardProps } from "./index";
import { transformAParam } from "utils/browser";
import { LinkTargetType } from "../../../../services/playground";
import { ProductImageTagViews } from "../../../LayerUI/ImageTagViews";
import CountDown from "../CountDown";

const TripleCard = (props: ProductCardProps) => {
	const {
		productElement,
		columnNum = 3,
		layoutStyle,
		placeholderBg,
		qnParams = {},
		isInApp,
		poolId,
		runtime,
	} = props;
	const collect = productElement.extra.collect;
	const titleIcon = productElement.extra.titleIcon?.img;
	const aProps = transformAParam({
		isInApp: !!isInApp,
		link: productElement.url,
		aTarget: LinkTargetType.Blank,
		onClick: props.onClick,
		isProductWrap: true,
		runtime,
	});

	const topLeftTag = productElement.extra?.imgOnTopLeft;
	const topLeftTag2 = productElement.extra?.imgOnTopLeft2;
	const flash = productElement.extra?.flash;

	return (
		<TripleCardWrap {...aProps} id={`${poolId}${productElement.gpid}`}>
			<BannerContainer
				banner={{
					img: productElement.img,
					link: productElement.url,
				}}
				className={"productPictureWrap"}
				placeholderBg={placeholderBg}
				qnParams={{ ...qnParams }}
				style={{
					position: "relative",
				}}
			>
				<ProductImageTagViews
					columnNum={3}
					leftTopTag={topLeftTag}
					leftTopTag2={topLeftTag2}
					isOnlyShowLeftTopTag={true}
				/>
				{flash?.countdownToEnd && (
					<CountDown
						countInfo={flash}
						needEndsIn={false}
						needIcon={false}
						needIconImg={true}
					/>
				)}
			</BannerContainer>
			<ProductInfoGrid3
				columnNum={columnNum}
				price={productElement.price}
				originPrice={productElement?.originPrice}
				name={productElement?.name}
				titleIcon={titleIcon}
				collect={collect}
				layoutStyle={layoutStyle}
				priceCurrency={productElement.priceCurrency}
				originPriceCurrency={productElement.originPriceCurrency}
				priceSymbol={productElement.priceSymbol}
				originPriceSymbol={productElement.originPriceSymbol}
			/>
		</TripleCardWrap>
	);
};
export default TripleCard;
